export default __webpack_public_path__ + "static/media/YashShah.98e84272.png";